var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.documentData)?_c('div',{style:({ height: _vm.containerHeight + 'px', overflow: 'auto' })},[_c('iframe',{attrs:{"src":_vm.documentData,"width":"100%","height":"100%"}})]):_vm._e(),(_vm.errorMessage)?_c('div',[_c('p',[_vm._v(_vm._s(_vm.errorMessage))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }